import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
} from "react-icons/fa";

const Navbar = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [mobileActiveDropdown, setMobileActiveDropdown] = useState(null);
  const [barVisible, setBarVisible] = useState(false);

  useEffect(() => {
    setBarVisible(true);
  }, []);

  const toggleDropdown = (dropdown) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  const closeDropdowns = () => setActiveDropdown(null);

  const toggleMobileDropdown = (dropdown) => {
    setMobileActiveDropdown(
      mobileActiveDropdown === dropdown ? null : dropdown
    );
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
    setMobileActiveDropdown(null);
  };

  const menuClass =
    "text-[#0b819b] hover:text-[#f97316] hover:bg-[#eafaff] px-3 py-1.5 rounded-full text-sm font-semibold transition-all duration-300 hover:-translate-y-0.5";

  const dropdownClass =
    "block px-4 py-2 text-sm text-[#0b819b] hover:bg-[#eafaff] hover:text-[#f97316] transition-colors duration-200";

  const mobileClass =
    "block text-[#0b819b] hover:text-[#f97316] hover:bg-[#eafaff] px-3 py-2 rounded-lg text-base font-semibold transition-colors duration-200";

  const socialLinks = [
    { icon: <FaFacebookF />, href: "#", label: "Facebook" },
    { icon: <FaInstagram />, href: "#", label: "Instagram" },
    { icon: <FaYoutube />, href: "#", label: "YouTube" },
    { icon: <FaLinkedinIn />, href: "#", label: "LinkedIn" },
  ];

  return (
    <div className="sticky top-0 z-50">
      <div
        className={`h-1 bg-gradient-to-r from-[#1298b5] via-[#74d6e8] to-[#f97316] transition-transform duration-700 ease-in-out ${
          barVisible ? "translate-y-0" : "-translate-y-full"
        }`}
      />

      <nav className="bg-white/95 backdrop-blur-md shadow-md border-b border-[#d8f4f8] font-sans">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-[74px]">
            <div className="flex-shrink-0">
              <Link to="/" onClick={closeMobileMenu}>
                <img
                  className="h-24 md:h-28 w-auto drop-shadow-md"
                  src="/logo.png"
                  alt="Aabharan Foundation"
                  style={{ objectFit: "contain" }}
                />
              </Link>
            </div>

            <div className="hidden md:flex flex-1 justify-center items-center space-x-1 lg:space-x-2">
              <Link to="/" className={menuClass} onClick={closeDropdowns}>
                Home
              </Link>

              <div className="relative">
                <button
                  onClick={() => toggleDropdown("about")}
                  className={`inline-flex items-center ${menuClass}`}
                >
                  About Us
                  <span
                    className={`ml-1 text-[10px] transition-transform duration-200 ${
                      activeDropdown === "about" ? "rotate-180" : ""
                    }`}
                  >
                    ▼
                  </span>
                </button>

                {activeDropdown === "about" && (
                  <div className="absolute left-0 mt-2 w-56 bg-white border border-[#d8f4f8] rounded-xl shadow-xl py-2 z-20 overflow-hidden">
                    <Link to="/about-us" className={dropdownClass} onClick={closeDropdowns}>
                      The Heart of Aabharan
                    </Link>
                    <Link to="/Director's -message" className={dropdownClass} onClick={closeDropdowns}>
                      Director's Message
                    </Link>
                    <Link to="/program" className={dropdownClass} onClick={closeDropdowns}>
                      Program
                    </Link>
                    <Link to="/board-member" className={dropdownClass} onClick={closeDropdowns}>
                      Board Member
                    </Link>
                    <Link to="/leadership" className={dropdownClass} onClick={closeDropdowns}>
                      Leadership
                    </Link>
                  </div>
                )}
              </div>

              <div className="relative">
                <button
                  onClick={() => toggleDropdown("join")}
                  className={`inline-flex items-center ${menuClass}`}
                >
                  Join Us
                  <span
                    className={`ml-1 text-[10px] transition-transform duration-200 ${
                      activeDropdown === "join" ? "rotate-180" : ""
                    }`}
                  >
                    ▼
                  </span>
                </button>

                {activeDropdown === "join" && (
                  <div className="absolute right-0 mt-2 w-48 bg-white border border-[#d8f4f8] rounded-xl shadow-xl py-2 z-20 overflow-hidden">
                    <Link to="/volunteer" className={dropdownClass} onClick={closeDropdowns}>
                      Volunteer
                    </Link>
                    <Link to="/career" className={dropdownClass} onClick={closeDropdowns}>
                      Career
                    </Link>
                  </div>
                )}
              </div>

              <Link
                to="/donation"
                onClick={closeDropdowns}
                className="bg-gradient-to-r from-[#1298b5] to-[#0b819b] text-white hover:from-[#f97316] hover:to-[#fb923c] px-5 py-1.5 rounded-full text-sm font-bold transition-all duration-300 shadow-md hover:shadow-lg hover:-translate-y-0.5"
              >
                Donate
              </Link>

              <Link to="/gallery" className={menuClass} onClick={closeDropdowns}>
                Gallery
              </Link>

              <Link to="/blog" className={menuClass} onClick={closeDropdowns}>
                Blog
              </Link>

              <Link to="/contact" className={menuClass} onClick={closeDropdowns}>
                Contact Us
              </Link>
            </div>

            <div className="hidden lg:flex items-center gap-2">
              {socialLinks.map((social, i) => (
                <a
                  key={i}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-[#eafaff] text-[#1298b5] hover:bg-[#1298b5] hover:text-white border border-[#d8f4f8] shadow-sm transition-all duration-300 hover:-translate-y-0.5"
                >
                  {social.icon}
                </a>
              ))}
            </div>

            <div className="md:hidden flex items-center">
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                className="p-2 rounded-lg text-[#1298b5] hover:text-[#f97316] hover:bg-[#eafaff] transition"
                aria-label="Open main menu"
              >
                <span className="text-2xl">☰</span>
              </button>
            </div>
          </div>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-[#d8f4f8] shadow-lg">
            <div className="px-3 pt-3 pb-4 space-y-1">
              <Link to="/" onClick={closeMobileMenu} className={mobileClass}>
                Home
              </Link>

              <button
                onClick={() => toggleMobileDropdown("about")}
                className="flex justify-between items-center w-full text-left text-[#0b819b] hover:text-[#f97316] hover:bg-[#eafaff] px-3 py-2 rounded-lg text-base font-semibold"
              >
                About Us <span>▼</span>
              </button>

              {mobileActiveDropdown === "about" && (
                <div className="pl-4 space-y-1">
                  <Link to="/about-us" onClick={closeMobileMenu} className={dropdownClass}>
                    The Heart of Aabharan
                  </Link>
                  <Link to="/Director's -message" onClick={closeMobileMenu} className={dropdownClass}>
                    Director's Message
                  </Link>
                  <Link to="/program" onClick={closeMobileMenu} className={dropdownClass}>
                    Program
                  </Link>
                  <Link to="/board-member" onClick={closeMobileMenu} className={dropdownClass}>
                    Board Member
                  </Link>
                  <Link to="/leadership" onClick={closeMobileMenu} className={dropdownClass}>
                    Leadership
                  </Link>
                </div>
              )}

              <button
                onClick={() => toggleMobileDropdown("join")}
                className="flex justify-between items-center w-full text-left text-[#0b819b] hover:text-[#f97316] hover:bg-[#eafaff] px-3 py-2 rounded-lg text-base font-semibold"
              >
                Join Us <span>▼</span>
              </button>

              {mobileActiveDropdown === "join" && (
                <div className="pl-4 space-y-1">
                  <Link to="/volunteer" onClick={closeMobileMenu} className={dropdownClass}>
                    Volunteer
                  </Link>
                  <Link to="/career" onClick={closeMobileMenu} className={dropdownClass}>
                    Career
                  </Link>
                </div>
              )}

              <Link to="/donation" onClick={closeMobileMenu} className={mobileClass}>
                Donate
              </Link>

              <Link to="/gallery" onClick={closeMobileMenu} className={mobileClass}>
                Gallery
              </Link>

              <Link to="/blog" onClick={closeMobileMenu} className={mobileClass}>
                Blog
              </Link>

              <Link to="/contact" onClick={closeMobileMenu} className={mobileClass}>
                Contact Us
              </Link>

              <div className="flex items-center gap-3 pt-3 pl-2">
                {socialLinks.map((social, i) => (
                  <a
                    key={i}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.label}
                    className="w-9 h-9 flex items-center justify-center rounded-full bg-[#eafaff] text-[#1298b5] hover:bg-[#1298b5] hover:text-white border border-[#d8f4f8]"
                  >
                    {social.icon}
                  </a>
                ))}
              </div>
            </div>
          </div>
        )}
      </nav>
    </div>
  );
};

export default Navbar;